import { checkInputValidity } from '../html/checkInputValidity'
import { showInputError } from '../html/showInputError'
import { getInputById } from './getInputById'

/**
 * Checks if required inputs are empty
 * @param {FunnelMainSubmitData} detail - The form fields
 * @param {FormSubmitFieldArray} inputs - The input ids
 * @returns {string[]} - The form error state
 */
export function checkSubmitInputs(detail, inputs) {
  const invalidInputs = inputs.reduce(
    (validAccumulator, field) => {
      const input = getInputById(field)

      if (!input || !checkInputValidity(input) || !detail[field]) {
        if (input) {
          showInputError(input)
        }
        validAccumulator.push(field)
      }

      return validAccumulator.filter((i) => i !== '')
    },
    [''],
  )
  return invalidInputs.filter((i) => i !== '')
}
